import gql from 'graphql-tag'

export const SUBSCRIBE_GET_CITIES = gql`
subscription {
 city {
    id
    city
    country
    shortCode
    state
    }
  }
 `